module.exports = __webpack_public_path__ + "static/media/react.ec0ef160.jpg";